import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { useIntl } from 'react-intl';
import { AuthoredEvidence, Evidence } from '@eas/common-web';
import { useColumns } from './system-users-columns';
import { Fields } from './system-users-fields';
import { SystemUser } from '@models';
import { ActionBar } from './system-users-actionbar';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';
import { useValidationSchema } from './system-users-schema';

export function SystemUsers() {
  const intl = useIntl();

  const validationSchema = useValidationSchema();

  const permissions = useEvidencePermission({
    options: {
      NEW: [Permission.Default.ADMINISTRATOR],
      EDIT: [Permission.Default.ADMINISTRATOR],
      REMOVE: [Permission.Default.ADMINISTRATOR],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [Permission.Default.ADMINISTRATOR],
      CHECK: [Permission.Default.ADMINISTRATOR],
      SAVE: [Permission.Default.ADMINISTRATOR],
      CLOSE: [Permission.Default.ADMINISTRATOR],
    },
  });

  const evidence = AuthoredEvidence.useAuthoredEvidence<SystemUser>({
    version: 2,
    identifier: 'SYSTEM_USERS',
    apiProps: {
      url: EvidenceApiUrl.SYSTEM_USERS,
    },
    tableProps: {
      tableName: intl.formatMessage({
        id: 'TAPIS__SYSTEM_USERS__TABLE__TITLE',
        defaultMessage: 'Správa systémových uživatelů',
      }),
      columns: useColumns(),
      reportTag: ExportTag.SYSTEM_USER_GRID,
    },
    detailProps: {
      FieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__SYSTEM_USERS__DETAIL__TITLE',
          defaultMessage: 'Správa systémových uživatelů',
        }),
        showBtn: permissions,
        ActionBar,
      },
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
